<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
    <div class="animated fadeIn">
      <div class="row mb-20">
        <div class="col-6">
          <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
        </div>
      </div>
      <div class="box">
        <div class="p-20">
          <div class="row mt-10">
            <div class="col-sm-6">
              <b-row>
                <b-col sm="3">
                  <label>Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
                </b-col>
              </b-row>
            </div>
            <div class="col-sm-6 text-right">
              <a class="btn-secondary text-center" @click="openPage('/allForm/grabAndGoProduct?product_type_id=2')"><i class="fas fa-plus mr-5"></i>Add Product</a>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-sm-6">
              <b-row>
                <b-col sm="3">
                  <label>Branch</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="branch" v-model="addDataMerchandise.branch_id" @change="changeBranch">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <div v-if="branch_validate">
                      <span class="error">The Branch field is required.</span>
                    </div>
                </b-col>
              </b-row>
            </div>
          </div>
          <template v-if="formType === 'merchandise'">
            <form @submit.prevent="validateMerchandise('merchandise')" data-vv-scope="grabAndGo">
              <div class="row justify-content-center mt-30">
                <div class="col-sm-6">
                  <b-row class="mb-20">
                    <b-col sm="4">
                      <label>Employee ID</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="addDataMerchandise.customer_service_id">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataCS" :key="item.id" :value="item.id">
                          <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                        </option>
                      </b-form-select>
                      <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-20">
                    <b-col sm="4">
                      <label>Customer Service Name</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <label>Created At</label>
                    </b-col>
                    <b-col sm="9">
                      <flat-pickr :config="config" v-model="addDataMerchandise.created_at" name="created_at" class="w-100"></flat-pickr>
                      <span class="error">{{ errors.first('date') }}</span>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-sm-6"></div>
              </div>
              <hr>
              <div class="mb-10">
                <div>Product List</div>
                <hr class="short-line left mb-20">
                <div class="table-grab-and-go">
                  <table class="w-100">
                    <thead>
                      <tr>
                        <th style="width: auto;">Product Name</th>
                        <th style="width: 200px;">Price</th>
                        <th style="width: 140px;">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(listProduct, index) in itemsProduct" :key="listProduct.id">
                        <td>
                          <b-form-input class="border-bottom bg-transparent" disabled v-model="listProduct.name" type="text"></b-form-input>
                        </td>
                        <td>
                          <money class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="listProduct.price" disabled v-bind="money2"></money>
                        </td>
                        <td>
                          <b-form-input class="border-bottom" name="quantity" v-validate="'required|numeric'" v-model="addDataMerchandise.quantity[index]" type="text"></b-form-input>
                          <span class="error">{{ errors.first('grabAndGo.quantity') }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-right">
                          <strong>Amount</strong>
                        </td>
                        <td>
                          <money :value="totalPayment" class="form-control border-bottom custom-currency w-100 bg-transparent" v-model="addDataMerchandise.amount" disabled v-bind="money2"></money>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr class="mt-30">
              <div class="mb-10">
                <div class="row">
                  <div class="col-lg-6">
                    <b-row class="mb-20">
                      <b-col sm="3">
                        <label>Member ID</label>
                      </b-col>
                      <b-col sm="9">
                        <div class="custom-search-select">
                          <model-select
                            autocomplete="false"
                            @searchchange="searchMemberWithoutBranch"
                            :options="optionsMember"
                            class="border-bottom"
                            name="member_id"
                            v-validate="'required'"
                            v-model="addDataMerchandise.redeem_member_id"
                          ></model-select>
                        </div>
                        <span class="error">{{ errors.first('ptSession.member_id') }}</span>
                      </b-col>
                    </b-row>

                    <b-row class="mb-20">
                      <b-col sm="3">
                        <label>Member Point</label>
                      </b-col>
                      <b-col sm="9">
                        <money
                          class="form-control border-bottom bg-transparent"
                          v-model="addDataMerchandise.memberPoint"
                          v-bind="money2"
                          disabled
                        ></money>
                      </b-col>
                    </b-row>
                    <b-row class="mb-20" v-if="addDataMerchandise.memberPoint > 0">
                      <b-col sm="3">
                        <label>Redeem Amount</label>
                      </b-col>
                      <b-col sm="9">
                        <money
                          class="form-control border-bottom bg-transparent"
                          v-model="addDataMerchandise.redeemAmount"
                          :value="redeemPayment"
                          v-bind="money2"
                        ></money>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>

              <hr class="mt-30">
              <div class="mb-10">
                <div>Payment Methods</div>
                <hr class="short-line left mb-20">
                <div class="row">
                  <div class="col-lg-7">
                    <b-row class="mb-20">
                      <b-col sm="3">
                        <div>Payment 1</div>
                      </b-col>
                      <b-col sm="9">
                        <div class="mb-20">
                          <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1" v-model="addDataMerchandise.payment_type_id_1" class="form-control border-bottom">
                            <option :value="null" selected>Please select</option>
                            <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                          </b-form-select>
                          <span class="error">{{ errors.first('grabAndGo.payment_type_id_1') }}</span>
                        </div>
                        <div class="mb-10">
                          <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1" :disabled="[1,6, 9].includes(addDataMerchandise.payment_type_id_1)" name="paymentCard1" v-model="addDataMerchandise.payment_card_id_1">
                            <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                          </b-form-radio-group>
                          <div v-if="![1,9].includes(addDataMerchandise.payment_type_id_1) && addDataMerchandise.payment_type_id_1 != null && addDataMerchandise.payment_card_id_1 == null">
                            <span class="error">The payment_card_id_1 field is required.</span>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="col-lg-5">
                    <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount" v-model="amountPaymentCard1" v-bind="money2"></money>
                    <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                      <span class="error">The payment first amount field is required.</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-7">
                    <b-row class="mb-20">
                      <b-col sm="3">
                        <div>Payment 2</div>
                      </b-col>
                      <b-col sm="9">
                        <div class="mb-20">
                          <b-form-select name="payment_type_id_2" @change="changePaymentType2" v-model="addDataMerchandise.payment_type_id_2" class="form-control border-bottom">
                            <option :value="null" selected>Please select</option>
                            <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{item.name}}</option>
                          </b-form-select>
                        </div>
                        <div class="mb-10">
                          <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2" :disabled="addDataMerchandise.payment_type_id_2 == 1 || addDataMerchandise.payment_type_id_2 == 6" name="paymentCard2" v-model="addDataMerchandise.payment_card_id_2">
                            <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                          </b-form-radio-group>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="col-lg-5">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                  </div>
                </div>
                <div class="row">
                  <b-col sm="2">
                    <div>Notes</div>
                  </b-col>
                  <b-col sm="10">
                    <textarea class="w-100" rows="5" v-model="addDataMerchandise.notes"></textarea>
                  </b-col>
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </template>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { Callout } from '@coreui/vue'
  import axios from 'axios'
  import { Auth } from '@/api'
  import moment from 'moment'
  import Mixin from '../../mixins/memberMixin'
  import { ModelSelect } from "vue-search-select";

  export default {
    name: 'addbranch',
    mixins:[Mixin],
    components: {
      ModelSelect
    },
    data: function () {
      return {
        linkDataPrivy: '',
        errorMoney: 'The amount field is required!',
        dataMember: [],
        dataBranch: [],
        dataCS: [],
        optionsMember: [{ value: null, text: "Please select" }],
        config: {
          altInput: true,
          altFormat: 'F j, Y',
          dateFormat: 'Y-m-d'
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        money2: {
          decimal: ',',
          thousands: '.',
          prefix: 'IDR ',
          suffix: '',
          precision: 0,
          masked: false
        },
        formType: 'merchandise',
        itemsPaymentCard: [],
        itemsPaymentType: [],
        itemsPaymentType2: [],
        detailMember: {},
        detailCS: {},
        CSName: '',
        modalShow: false,
        linkPrivyId: 'https://sandbox.privy.id/user',
        branch_validate: false,
        tempAmount: 0,
        addDataMerchandise: {
          customer_service_id: null,
          branch_id: null,
          amount: '',
          product_id: [],
          quantity: [],
          detail_amount: [],
          payment_type_id_1: null,
          payment_card_id_1: null,
          payment_amount_1: '',
          payment_type_id_2: null,
          payment_card_id_2: null,
          payment_amount_2: '',
          notes: '',
          created_at: '',
          memberPoint: 0,
          redeemAmount: 0,
          redeem_amount: 0,
          redeem_member_id: null,
          product_type_id: 2
        },
        itemsProduct: [],
        totalFinalProduct: [],
        amountPaymentCard1: '',
        amountPaymentCard2: '',
        options: [
          { value: null, text: 'Please select' },
          { value: 'freeze', text: 'Freeze' },
          { value: 'cancel', text: 'Cancel' },
          { value: 'outstanding', text: 'Outstanding' },
          { value: 'wristband', text: 'Wristband' },
          { value: 'lostAndFound', text: 'Lost & Found' },
          { value: 'dailyVisit', text: 'Daily Visit' },
          { value: 'grabAndGo', text: 'Grab & Go' },
          { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
          { value: 'extendPt', text: 'Extend PT' },
          { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
          { value: 'merchandise', text: 'Merchandise' },
          { value: 'starterPack', text: 'Starter Pack' }
        ]
      }
    },
    methods: {
      onAppliedRedeemPoint() {
        this.addDataMerchandise.amount = ""
        // console.log(this.addDataMerchandise.redeemAmount)
        // this.addDataMerchandise.amount = this.tempAmount - this.addDataMerchandise.redeemAmount
        // console.log(this.addDataMerchandise.amount)
      },
      changeFormType (event) {
        if (event === 'freeze') {
          this.$router.push('/allForm/addFreeze')
        } else if (event === 'cancel') {
          this.$router.push('/allForm/addCancel')
        } else if (event === 'outstanding') {
          this.$router.push('/allForm/addOutstanding')
        } else if (event === 'wristband') {
          this.$router.push('/allForm/addWristband')
        } else if (event === 'lostAndFound') {
          this.$router.push('/allForm/addLostAndFound')
        } else if (event === 'dailyVisit') {
          this.$router.push('/allForm/addDailyVisit')
        } else if (event === 'grabAndGo') {
          this.$router.push('/allForm/addGrabAndGo')
        } else if (event === 'grabAndGoGopay') {
          this.$router.push('/allForm/addgrabAndGoGopay')
        } else if (event === 'corporateOutstanding') {
          this.$router.push('/allForm/addCorporateOutstanding')
        } else if (event === 'extendPt') {
          this.$router.push('/allForm/addExtendPt')
        } else if (event === 'merchandise') {
          this.$router.push('/allForm/addMerchandise')
        } else if (event === 'starterPack') {
          this.$router.push('/allForm/addStarterPack')
        } else {
          this.$router.push('/allForm/add')
        }
      },
      formatPrice(value) {
          let val = (value/1).toFixed(0).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async changePaymentCard1 (event) {
        let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
        this.itemsPaymentType = payment_card.data.data.rows
      },
      async changePaymentCard2 (event) {
        let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
        this.itemsPaymentType2 = payment_card.data.data.rows
      },
      changePaymentType1 (event) {
        if (event === 1) {
          this.addDataMerchandise.payment_card_id_1 = null
        } else if (event === 6) {
          this.addDataMerchandise.payment_card_id_1 = 1
        } else {
          this.addDataMerchandise.payment_card_id_1 = null
        }
      },
      changePaymentType2 (event) {
        if (event === 1) {
          this.addDataMerchandise.payment_card_id_2 = null
        } else if (event === 6) {
          this.addDataMerchandise.payment_card_id_2 = 1
        } else {
          this.addDataMerchandise.payment_card_id_2 = null
        }
      },
      getMemberData (event) {
        axios.get('fitness/v1/member/' + event).then(response => {
          this.detailMember = response.data.data
          this.addDataPrivy.branch_id = response.data.data.branch_id
          this.addDataPrivy.member_id = response.data.data.id
          // console.log('test', response)
        }).catch(error => {
          console.log('error', error)
        })
      },
      getCSData (event) {
        axios.get('crm/v1/customer_service/' + event).then(response => {
          this.detailCS = response.data.data
          this.CSName = response.data.data.name
          this.addDataPrivy.customer_id = response.data.data.id
          // console.log('test', response)
        }).catch(error => {
          console.log('error', error)
        })
      },
      formSelect (event) {
        return event
      },
      changeValueMoney (event) {
        if (!(event.key === '')) {
          this.$refs['error-print'].classList.add('hidden')
        } else {
          this.$refs['error-print'].classList.remove('hidden')
        }
      },
      validateMerchandise (data7) {
        // console.log('dataQuantity', this.addDataMerchandise.quantity)
        // console.log('dataQuantity', this.addDataMerchandise.quantity[2])
        this.$validator.validateAll(data7).then((result) => {
          if (![1,9].includes(this.addDataMerchandise.payment_type_id_1) && this.addDataMerchandise.payment_card_id_1 == null) {
            this.$toast.success('please fill in required fields!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            return
          }

          if (this.addDataMerchandise.branch_id == null) {
            this.branch_validate = true
            this.$toast.success('The Branch field is required!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            return
          }

          if(result) {
            this.addDataMerchandise.payment_amount_1 = this.amountPaymentCard1
            this.addDataMerchandise.payment_amount_2 = this.amountPaymentCard2
            this.addDataMerchandise.redeem_amount = this.addDataMerchandise.redeemAmount

            // console.log(this.addDataMerchandise)
            // alert
            this.$swal({
                title: 'Are you sure?',
                text: 'You can\'t revert your action',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Save now!',
                cancelButtonText: 'No, Cancel it!',
                showCloseButton: true,
                showLoaderOnConfirm: false
            }).then((confirm) => {
                if(confirm.value) {
                    axios.post('crm/v1/form_grab_and_go/', this.addDataMerchandise).then(response => {
                      console.log('test', response)
                      this.$router.push('/allForm')
                      this.$toast.success('data saved successfully!', 'Success', {
                        position: 'topCenter',
                        icon: 'icon-envelope',
                        progressBarColor: 'rgb(0, 255, 184)',
                        theme: 'dark',
                        backgroundColor: '#565c70',
                        messageColor: '#fff'
                      })
                    }).catch(error => {
                      console.log('error log', error)
                      this.$toast.success('cant saved data!', 'Error', {
                        position: 'topCenter',
                        icon: 'icon-envelope',
                        progressBarColor: 'rgb(0, 255, 184)',
                        theme: 'dark',
                        backgroundColor: '#565c70',
                        messageColor: '#fff'
                      })
                    })
                } else {
                    this.$swal('Cancelled', 'Your file is still intact', 'info')
                }
            })

            // console.log('test', this.addDataMerchandise)

          } else {
            this.$toast.success('please fill in required fields!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        })
      },
      changeBranch(event) {
        this.branch_validate = false
        // this.getMemberWithoutBranch()
        axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
          this.dataCS = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      },
      openPage (event) {
        this.$router.push(event)
      },
      fetchData() {
        this.getMemberWithoutBranch()
        this.addDataMerchandise.created_at = moment(new Date()).format('YYYY-MM-DD H:m')
        axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
          this.itemsPaymentCard = response.data.data.rows
          // console.log('test', response.data.data.rows)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
          this.itemsPaymentType = response.data.data.rows
          this.itemsPaymentType2 = response.data.data.rows
          // console.log('test', response.data.data.rows)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/customer_service/').then(response => {
          this.dataCS = response.data.data.rows

          if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
            // filter cs member
            this.dataCS = this.dataCS.filter(cs => cs.id == Auth.Session.get().paradigm_id)
          }
          // console.log('test', response)
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('crm/v1/grab_and_go_product?product_type_id=2').then(response => {
          // price bertipe DECIMAL (string "15000.00"), jadikan number agar format IDR (v-money precision 0) benar
          this.itemsProduct = response.data.data.rows.map(item => Object.assign({}, item, { price: Number(item.price) }))
          var i
          for(i = 0; i < this.itemsProduct.length; i++) {
            this.addDataMerchandise.product_id[i] = this.itemsProduct[i].id
            this.addDataMerchandise.detail_amount[i] = this.itemsProduct[i].price
            this.addDataMerchandise.quantity[i] = 0
          }
        }).catch(error => {
          console.log('error', error)
        })
        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
          if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
            // filter branch member
            this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
          }
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    computed: {
      totalPayment: function() {
        console.log('Exec')
        var i
        for(i = 0; i < this.itemsProduct.length; i++) {
          this.totalFinalProduct[i] = this.addDataMerchandise.detail_amount[i] * this.addDataMerchandise.quantity[i]
        }

        this.addDataMerchandise.amount = this.totalFinalProduct.reduce((a,b)=>{return a+b},0)
        this.amountPaymentCard1 = this.addDataMerchandise.amount
        let calculatedTotal = this.addDataMerchandise.amount

        if (this.addDataMerchandise.redeemAmount > 0 && this.addDataMerchandise.amount > 0 ) {
          this.addDataMerchandise.amount = calculatedTotal - this.addDataMerchandise.redeemAmount
          this.amountPaymentCard1 = this.addDataMerchandise.amount
        }
        return calculatedTotal
      },
      paymentLeft: function() {
        if (String(this.amountPaymentCard1).length > String(this.addDataMerchandise.amount).length) {
          // console.log('test')
          this.amountPaymentCard2 = 0
        } else {
          this.amountPaymentCard2 = this.addDataMerchandise.amount - this.amountPaymentCard1
          this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
        }
      },
      redeemPayment: function() {
        if (this.addDataMerchandise.redeemAmount > this.addDataMerchandise.memberPoint) {
          this.$toast.success("Not enough point", "Error", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
                this.addDataMerchandise.redeemAmount = 0;
          return this.addDataMerchandise.redeemAmount
        } else {
          return this.addDataMerchandise.redeemAmount
        }
      },
      getMemberId: function() {
        return this.addDataMerchandise.redeem_member_id;
      },

    },
    watch: {
      onAppliedRedeemPoint: function() {
        return this.addDataMerchandise.amount
      },
      getMemberId() {
        axios.get("mobile/v1/my_rewards/total_rewards?member_id="+this.addDataMerchandise.redeem_member_id)
          .then(response => {
            this.addDataMerchandise.memberPoint = response.data.data[0].total_amount
          })
          .catch(error => {
            console.log("error", error);
          })
      }
    },
    created () {
      this.fetchData()

      const roleId = Auth.Session.get().paradigm_role
      if (roleId == 6 || roleId == '6') {
        this.addDataMerchandise.branch_id = Auth.Session.get().paradigm_branch_id
        this.addDataMerchandise.customer_service_id = Auth.Session.get().paradigm_id

        this.getCSData(this.addDataMerchandise.customer_service_id)
      }
    }
  }
  </script>

  <style>
  </style>
